<template>
  <section class="open-positions-module-component">
    <div class="inner-container">
      <div class="line"></div>
      <div class="heading-area">
        <h2 class="title">{{ data.open_positions.title }}</h2>
        <div class="filter-area flex justify-between">
          <div class="departments-dropdown">
            <select
              v-if="false"
              id="departments"
              name="departments"
              :onChange="(e) => (selectedDepartment = e.target.value)">
              <option
                v-for="department in departments"
                :key="department.title"
                :value="department.title">
                {{ department.title }}
              </option>
            </select>
          </div>
          <div class="locations-dropdown flex">
            <div v-if="loading">
              <div class="flex items-center w-full">
                <div class="h-4 bg-gray-200 rounded-full w-32"></div>
                <div class="h-4 ms-2 bg-gray-300 rounded-full w-24"></div>
                <div class="h-4 ms-2 bg-gray-300 rounded-full w-full"></div>
              </div>
            </div>
            <div
              v-for="(department, index) of locations"
              :key="`departments-${index}`"
              class="option">
              <input
                type="radio"
                class="radio mr-2"
                name="locations"
                :checked="index === 0 ? true : false"
                @click="selectedLocation = department" />
              <label :for="department">{{ department }}</label>
            </div>
          </div>
        </div>
      </div>
      <div class="content-area">
        <template v-if="loading">
          <div
            v-for="i in 5"
            :key="`skeleton-${i}`"
            class="skeleton px-12 py-10 flex flex-col lg:flex-row gap-6 justify-between border-b-[1px] border-b-lm_orange">
            <div
              role="status"
              class="animate-pulse w-full lg:w-6/12">
              <div class="flex items-center w-full mb-6">
                <div class="h-10 bg-gray-200 rounded-full w-32"></div>
                <div class="h-10 ms-2 bg-gray-300 rounded-full w-24"></div>
                <div class="h-10 ms-2 bg-gray-300 rounded-full w-full"></div>
              </div>
              <div class="flex items-center w-full">
                <div class="h-4 bg-gray-200 rounded-full w-32"></div>
                <div class="h-4 ms-2 bg-gray-300 rounded-full w-24"></div>
              </div>
            </div>
            <div
              role="status"
              class="animate-pulse max-w-lg">
              <div class="flex items-center w-full mb-6">
                <div class="h-16 bg-gray-200 rounded-lg w-56"></div>
              </div>
            </div>
          </div>
        </template>
        <div
          v-for="(opening, indx) of positions"
          :key="`opening-${indx}`"
          class="opening-item">
          <div class="title-area">
            <div class="title">{{ opening.title }}</div>
            <div class="location">
              <!-- {{ opening.location.name + ' | ' + opening.departments }} -->
              {{ opening.location.name }}
            </div>
          </div>
          <ButtonGlobal
            class="position-cta-button"
            :text="data.open_positions.button_text"
            :url="opening.absolute_url"
            target="_blank" />
        </div>
      </div>
      <div class="load-more">
        <ButtonGlobal
          v-if="positions.length > 0 && positions.length >= currentlyDisplayed"
          class="load-more-button"
          text="Load More"
          @click="getFivePositions(currentlyDisplayed)" />
        <p
          v-if="positions.length < 5 || positions.length < currentlyDisplayed"
          class="end-of-list"></p>
      </div>
    </div>
  </section>
</template>

<script setup>
import { onBeforeMount, ref, watch } from 'vue'
import ButtonGlobal from '@/components/utility/ButtonGlobal.vue'

/* #META
 {
  "NAME": "OpenPositionsComponent",
  "CLASSNAME": "open-positions-module-component",
  "URL": "http://lifemine.local/templates/"
 }
#ENDMETA */
defineProps(['data'])
const locations = ref([])
const departments = ref([])
const positions = ref([])
const allPositions = ref([])
const loading = ref(false)
const selectedDepartment = ref('All Departments')
const selectedLocation = ref('All Locations')
const currentlyDisplayed = ref(5)

// Mock API call waiting for real data
const fetchData = async () => {
  loading.value = true
  return new Promise((resolve, reject) => {
    try {
      setTimeout(async () => {
        const response = await fetch(
          'https://boards-api.greenhouse.io/v1/boards/lifeminetx/jobs'
        )
        const data = await response.json()
        allPositions.value = data.jobs
        // Delete this data injection when real data is available
        // injectDepartment(data.jobs)
        // End Delete this data injection when real data is available
        getLocations(data.jobs)
        getFivePositions(0)
        loading.value = false
        resolve(data)
      }, 3000)
    } catch (error) {
      reject(error)
    }
  })
}

const getLocations = (data) => {
  const finalLocations = []
  data.forEach((opening) => {
    finalLocations.push(opening.location.name)
  })
  finalLocations.unshift('All Locations')
  const LocationData = [...new Set(finalLocations)]
  locations.value = LocationData
}

const getFivePositions = (index) => {
  let data
  if (
    selectedDepartment.value === 'All Departments' &&
    selectedLocation.value === 'All Locations'
  ) {
    data = allPositions.value
  } else {
    data = filterOpenings()
  }
  const newSlice = data.slice(index, index + 5)
  positions.value = [...positions.value, ...newSlice]
  currentlyDisplayed.value = index + 5
}

const filterOpenings = () => {
  // filter by department
  const filteredByDepartment = allPositions.value.filter((opening) => {
    if (selectedDepartment.value === 'All Departments') {
      return opening
    } else {
      if (opening.departments.includes(selectedDepartment.value)) {
        return opening
      }
    }
  })
  // filter by location
  const filteredByLocation = filteredByDepartment.filter((opening) => {
    if (selectedLocation.value === 'All Locations') {
      return opening
    } else {
      if (opening.location.name.includes(selectedLocation.value)) {
        return opening
      }
    }
  })
  return filteredByLocation
}

onBeforeMount(async () => {
  await fetchData()
})

watch([selectedDepartment, selectedLocation], () => {
  positions.value = []
  currentlyDisplayed.value = 5
  getFivePositions(0)
})

// Mock data// Mock data// Mock data// Mock data// Mock data// Mock data// Mock data// Mock data
// departments.value = [
//   { id: 0, title: 'All Departments' },
//   { id: 1, title: 'Engineering' },
//   { id: 2, title: 'Product' },
//   { id: 3, title: 'Marketing' },
//   { id: 4, title: 'Sales' },
//   { id: 5, title: 'Customer Success' },
//   { id: 6, title: 'Finance' },
//   { id: 7, title: 'Legal' },
//   { id: 8, title: 'People' },
// ]
// const injectDepartment = (openings) => {
//   openings.forEach((opening, indx) => {
//     if (indx < 6) {
//       opening.departments = 'Engineering'
//     } else {
//       opening.departments = 'Product'
//     }
//   })
// }
// End Mock data// End Mock data// End Mock data// End Mock data// End Mock data// End Mock data
</script>

<style lang="scss">
.open-positions-module-component {
  @apply relative;
  .inner-container {
    @apply py-16;
    .line {
      @apply absolute w-[1px] h-full lg:left-[60px] xl:left-[75px] top-0;
      background: linear-gradient(180deg, #ffad39 60%, #382c75 100%);
    }
    .heading-area {
      @apply px-10 pb-10 border-b border-lm_orange;
      .title {
        @apply text-[42px] leading-[50px] lg:text-[46px] lg:leading-[50px] text-lm_purple mb-8;
      }
      .filter-area {
        @apply flex flex-col lg:flex-row gap-8;
        .departments-dropdown {
          @apply mr-6;
          select {
            @apply h-12 border border-lm_purple small pl-5 pr-24;
            background: transparent;
            background-image: url('@/assets/img/Scroll.svg');
            background-repeat: no-repeat;
            background-position-x: 100%;
            background-position-y: 0px;
            background-size: 16%;
          }
        }
        .locations-dropdown {
          @apply flex flex-col lg:flex-row gap-4;
          .option {
            @apply mr-6 flex items-center;
            .radio {
              @apply w-5 h-5 rounded-full text-lm_purple bg-white border-lm_purple focus:ring-transparent;
            }
            [type='radio']:checked {
              background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='%23382C75' xmlns='http://www.w3.org/2000/svg'%3e%3ccircle cx='8' cy='8' r='5'/%3e%3c/svg%3e");
            }
            label {
              @apply text-lg;
            }
          }
          .option:last-child {
            @apply mr-0;
          }
        }
      }
    }
    .content-area {
      .opening-item {
        @apply border-b border-lm_orange py-8 px-12 flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6;
        .title-area {
          .title {
            @apply heading-4 text-black mb-2;
          }
          .location {
            @apply text-lm_orange text-[20px] lg:large;
          }
        }
        .position-cta-button {
          @apply translate-x-0 w-fit;
          a {
            @apply border-2 border-lm_purple bg-white;
          }
        }
      }
    }
    .load-more {
      @apply mt-14;
      .load-more-button {
        @apply translate-x-0 mx-auto;
        .button {
          @apply bg-lm_purple;
          span {
            @apply text-white;
          }
        }
      }
      .end-of-list {
        @apply text-center heading-4 text-gray-300;
      }
    }
  }
}
</style>
